// EFM case sub-types (only Appellate cases in LA County have sub-types)
// Sub-types are very rare — only 4 out of 213 case types have them
// Sub-types for Appellate case types
export const APPELLATE_SUB_TYPES = {
    // Appellate Division Pre-Appeal Motion
    'AP6154O': [
        { code: 'APC', name: 'Limited Civil', caseTypeCode: 'AP6154O' },
        { code: 'API', name: 'Infraction', caseTypeCode: 'AP6154O' },
        { code: 'APM', name: 'Misdemeanor', caseTypeCode: 'AP6154O' },
    ],
    // Petition for Writ - Habeas Corpus
    'AP6155': [
        { code: 'API', name: 'Infraction', caseTypeCode: 'AP6155' },
        { code: 'APM', name: 'Misdemeanor', caseTypeCode: 'AP6155' },
    ],
    // Petition for Writ - Mandate
    'AP6152': [
        { code: 'APC', name: 'Limited Civil', caseTypeCode: 'AP6152' },
        { code: 'API', name: 'Infraction', caseTypeCode: 'AP6152' },
        { code: 'APM', name: 'Misdemeanor', caseTypeCode: 'AP6152' },
    ],
    // Petition for Writ - Other
    'AP6153': [
        { code: 'APC', name: 'Limited Civil', caseTypeCode: 'AP6153' },
        { code: 'API', name: 'Infraction', caseTypeCode: 'AP6153' },
        { code: 'APM', name: 'Misdemeanor', caseTypeCode: 'AP6153' },
    ],
};
export const getCaseSubTypes = (caseTypeCode) => {
    return APPELLATE_SUB_TYPES[caseTypeCode] || [];
};
export const hasCaseSubTypes = (caseTypeCode) => {
    return caseTypeCode in APPELLATE_SUB_TYPES;
};
